<div class="country-flag-wrapper inline-block">
  <div *ngIf="country$ | async as country" [ngClass]="['flex items-center justify-center', suffixIcon?'flex-row-reverse':'flex-row']">
    <span [ngClass]="['flag-icon','fi', 'fi-' + country.code.toLowerCase(),suffixIcon?'ml-2':'mr-2']" ></span>
    <span *ngIf="showCountryName" class="country-name">{{ country.name }}</span>
  </div>
</div>

